import store from '../store/Store';
import actionTypes from '../actionTypes/actionTypes';

async function openMenu() {
	const action = {
		type: actionTypes.OPEN_MENU
	};

	store.dispatch(action);
}

async function closeMenu() {
	const action = {
		type: actionTypes.CLOSE_MENU
	};

	store.dispatch(action);
}

async function openLanguage() {
	const action = {
		type: actionTypes.OPEN_LANGUAGE
	};

	store.dispatch(action);
}

async function closeLanguage() {
	const action = {
		type: actionTypes.CLOSE_LANGUAGE
	};

	store.dispatch(action);
}

async function changeLanguage(data) {
	const action = {
		type: actionTypes.ACTIVE_LANGUAGE,
		data
	};

	store.dispatch(action);
}

async function setScreenWidth(data) {
	const action = {
		type: actionTypes.SET_SCREEN_WIDTH,
		data
	};

	store.dispatch(action);
}

async function setScreenHeight(data) {
	const action = {
		type: actionTypes.SET_SCREEN_HEIGHT,
		data
	};

	store.dispatch(action);
}

async function setInnerWidth(data) {
	const action = {
		type: actionTypes.SET_INNER_WIDTH,
		data
	};

	store.dispatch(action);
}

async function setInnerHeight(data) {
	const action = {
		type: actionTypes.SET_INNER_HEIGHT,
		data
	};

	store.dispatch(action);
}

const menuActions = {
	openMenu,
	closeMenu,
	openLanguage,
	closeLanguage,
	changeLanguage,
	setScreenWidth,
	setScreenHeight,
	setInnerWidth,
	setInnerHeight
}

export default menuActions;